var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service}},[_c('TableText',{attrs:{"prop":"title","label":"标题"}}),_c('TableAction',{attrs:{"buttons":[
    { name: '查看评论', onClick: (row) => _vm.handleComment(row.id) },
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":300}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }